import type { CostServiceType } from 'packages/lib/api/annotations-ops/clients/cost/cost-service';
import {
  buildMockCostGroups,
  buildMockCostSeries,
  buildMockGroupHierarchy,
  buildMockTaskTypes,
} from 'packages/lib/api/annotations-ops/clients/cost/mock/mock-cost-data';
import {
  buildMockTaskCost,
  buildMockUserCost,
} from 'packages/lib/api/annotations-ops/clients/cost/mock/mock-contributor-data';
import {
  costGroupResponseZod,
  costSeriesResponseZod,
  costTaskResponseZod,
  costUserResponseZod,
  groupHierarchyResponseZod,
  taskTypesResponseZod,
} from 'packages/lib/api/annotations-ops/contract';

// 2026-08-04 Used Cursor (Opus 5) to generate initial API methods
// 2026-10-05 Used Cursor (Claude Opus 5.5 Medium) to add Contributor and Task views
// 2026-10-30 Used Cursor (Claude Opus 5.5) to collect the mock endpoints into one CostService

/**
 * Every Cost endpoint, answered from the mock hierarchy. Responses are parsed with the
 * same schemas as the live client, so the mocks cannot drift from the contract.
 */
export const mockCostService: CostServiceType = {
  source: 'mock',
  getGroupCost: async (query) =>
    costGroupResponseZod.parse(buildMockCostGroups(query)),
  getTimeSeries: async (query) =>
    costSeriesResponseZod.parse(buildMockCostSeries(query)),
  getTaskCost: async (taskToken) =>
    costTaskResponseZod.parse(buildMockTaskCost(taskToken)),
  getUserCost: async (query) =>
    costUserResponseZod.parse(buildMockUserCost(query)),
  getTaskTypes: async (query) =>
    taskTypesResponseZod.parse(buildMockTaskTypes(query)),
  getGroupHierarchy: async (groupType, token) =>
    groupHierarchyResponseZod.parse(buildMockGroupHierarchy(groupType, token)),
};
